import React, { useCallback, useRef, useState } from 'react'
import { Tooltip } from '../../Tooltip'
import { ReactComponent as PermalinkIcon } from '../../../Icons/assets/permalink-icon.svg'
import { IconButton, IconButtonVariant, OverrideIcon } from '../IconButton'

export const PermalinkButton = ({
  permalinkUrl,
  isPermalink,
  placement = 'top',
  disabled = false,
  tooltipBody = '',
  icon,
  text,
  isMenuItem = false,
  hoverBgColor,
  svgHoverBgColor,
}: {
  permalinkUrl: string
  isPermalink: boolean
  placement?: 'top' | 'bottom' | 'left' | 'right'
  disabled?: boolean
  tooltipBody?: string
  icon?: React.ReactNode
  text?: string
  isMenuItem?: boolean
  hoverBgColor?: string
  svgHoverBgColor?: string
}): JSX.Element => {
  const [isClicked, setIsClicked] = useState(false)
  const [show, setShow] = useState(false)
  const onClickTimeoutRef = useRef(0)

  const id = Math.random() * 1000000
  const linkText = tooltipBody || (isPermalink ? 'Copy Permalink' : 'Copy Link')

  const onClick = useCallback(
    async (e: React.MouseEvent<HTMLButtonElement | HTMLSpanElement>) => {
      e.preventDefault()
      window.clearTimeout(onClickTimeoutRef.current)
      setIsClicked(true)
      setShow(true)
      onClickTimeoutRef.current = window.setTimeout(() => {
        setShow(false)
      }, 300)
      await navigator.clipboard.writeText(permalinkUrl)
    },
    [permalinkUrl],
  )

  return (
    <Tooltip
      id={`permalink-tooltip-${id}`}
      trigger={['hover', 'click']}
      show={show}
      onToggle={(nextShow) => {
        setIsClicked(false)
        setShow(nextShow)
      }}
      placement={placement}
      tooltipBody={isClicked ? 'Copied!' : linkText}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <IconButton
          disabled={disabled}
          variant={IconButtonVariant.icon}
          onClick={onClick}
          $hoverBgColor={hoverBgColor}
          $svgHoverBgColor={svgHoverBgColor}
          $isMenuItem={isMenuItem}
        >
          {icon ? (
            <OverrideIcon>{icon}</OverrideIcon>
          ) : (
            <PermalinkIcon width="24px" height="24px" />
          )}
        </IconButton>
        {text && <span onClick={onClick}>&nbsp;&nbsp;{text}</span>}
      </div>
    </Tooltip>
  )
}

PermalinkButton.defaultProps = {
  isPermalink: false,
}
